var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "news-card-featured-wrapper",
      on: {
        click: function($event) {
          return _vm.navigateToNewsPost()
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-6 pr-md-3" }, [
          _vm.imgUrl
            ? _c("img", {
                staticClass: "card-img mr-3",
                attrs: { src: _vm.imgUrl, alt: "News image" },
                on: { error: _vm.handleImgLoadError }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6 pt-md-0 pl-md-1 mt-n3 mt-md-0" },
          [
            _c(
              "div",
              { staticClass: "news-card-body px-0" },
              [
                _c("news-card-details", {
                  staticClass: "pb-1 pb-md-0",
                  attrs: { date: _vm.postData.date }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pt-1" }, [
                  _c("h3", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.postData.title))
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "card-description",
                  domProps: {
                    innerHTML: _vm._s(_vm.postData.description + "...")
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-054c281e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054c281e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/news/NewsCardFeatured.vue
// module id = null
// module chunks = 